import styled from 'styled-components';
const Container = styled.figure `
  mask-image: var(--mask);
  mask-repeat: no-repeat;
  mask-position: center;
  mask-size: contain;
`;
const ImageStyles = {
    Container,
};
export default ImageStyles;
